module.exports = __webpack_public_path__ + "static/media/squared.ab0db400.svg";